<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/intro">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">1. Prescott, Maiden City of Arizona</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. A Tough Life</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. Murder in the Red-Light District</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. Ladies of the Line</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. Queens of the Row</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. The Strange Fate of Mollie Sheppard</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. Lida Winchell, From Rags to Riches to Rags</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. In Defense of Gabriell Dollie Wiley</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. The Law Is the Law</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. A Look Back</span></p>
<p class="toc1"><span href="#/note" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?44ebe1a6